// Attraction Desire V1 - Reviews progressive reveal
(function(){
  var grid = document.getElementById('av1-reviews-grid');
  var btn = document.getElementById('av1-see-more-reviews');
  if (!grid || !btn) return;
  var cards = grid.querySelectorAll('.av1-rcard');
  var initialVisible = parseInt(grid.getAttribute('data-initial') || '4', 10);
  var step = parseInt(grid.getAttribute('data-step') || '4', 10);
  cards.forEach(function(c, i){ if (i >= initialVisible) c.classList.add('av1-rcard--hidden'); });
  if (cards.length <= initialVisible) { btn.style.display = 'none'; return; }
  btn.addEventListener('click', function(){
    var hidden = grid.querySelectorAll('.av1-rcard--hidden');
    for (var i = 0; i < step && i < hidden.length; i++) hidden[i].classList.remove('av1-rcard--hidden');
    if (grid.querySelectorAll('.av1-rcard--hidden').length === 0) btn.style.display = 'none';
  });
})();
